import {AuthorizationFetcher, FetcherUtils, utils} from '@wallaby-ui/core';
import {LIBRARY_NAME} from 'src/js/common/constants';
import {CONFLICT_HTTP_CODE} from 'src/js/containers/auto_layout/auto_layout_constants';
import {KEYWORD_DATA_CONTENT, KEYWORD_DATA_CONTENT_LAST_CHANGE_TIMESTAMP} from 'src/js/model/auto_layout_screen_data_helpers';

const logger = utils.LogUtils.getLogger('AutoLayoutFetcher', LIBRARY_NAME);

/** @deprecated */
const AutoLayoutFetcher = {
  getMetadata(requestUrl, screenId, metadataMethod) {
    if (!requestUrl || !metadataMethod) {
      logger.error(`Missing request endpoint, requestUrl: ${requestUrl}, requestMethod: ${metadataMethod}`);
    }
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}/${encodeURIComponent(screenId)}/${metadataMethod}`,
      {method: 'get'},
      {'Content-Type': 'application/json'}
    )
      .then(FetcherUtils.processJsonResponse)
      .catch((response) => {
        FetcherUtils.errorHandler(response);
      });
  },

  getData(requestUrl, screenId, params) {
    if (!requestUrl || !screenId) {
      logger.error(`Missing request endpoint, requestUrl: ${requestUrl}, screenId: ${screenId}`);
    }
    const queryParams = FetcherUtils.transformJSONToUrlEncodedParams(params);
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}/${encodeURIComponent(screenId)}/?${queryParams}`,
      {method: 'get'},
      {'Content-Type': 'application/json'}
    )
      .then(FetcherUtils.processJsonResponse)
      .catch((response) => {
        FetcherUtils.errorHandler(response);
      });
  },

  /**
   * Posts data of screen to the backend API.
   *
   * @returns {Promise<{_responseData : Object, _responseStatus: number}>|Promise<Object>}
   */
  saveData(requestUrl, screenId, data, params) {
    if (!requestUrl || !screenId) {
      logger.error(`Missing request endpoint, requestUrl: ${requestUrl}, screenId: ${screenId}`);
    }
    const queryParams = utils.FetcherUtils.transformJSONToUrlEncodedParams(params);
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}/${encodeURIComponent(screenId)}/?${queryParams}`,
      {method: 'post', body: JSON.stringify({...data, ...params})},
      {'Content-Type': 'application/json'}
    )
      .then((response) => {
        let result;
        // HTTP Error 409 is not considered as an error
        if (response.status === CONFLICT_HTTP_CODE) {
          // return response data and response status
          result = response.json().then((resultJson) => ({
            _responseData: resultJson,
            _responseStatus: response.status,
          }));
        } else if (response.type === 'opaque' || response.ok) {
          const promise = response.status === utils.FetcherUtils.HTTP_STATUS_NO_CONTENT ? Promise.resolve({}) : response.json();
          result = promise.then((resultJson) => ({
            _responseData: resultJson,
            _responseStatus: response.status,
          }));
        } else {
          utils.FetcherUtils.errorHandler(response);
        }
        return result;
      })
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },

  removeData(requestUrl, screenId, data, params) {
    if (!requestUrl || !screenId) {
      logger.error(`Missing request endpoint, requestUrl: ${requestUrl}, screenId: ${screenId}`);
    }
    const queryParams = utils.FetcherUtils.transformJSONToUrlEncodedParams({
      ...params,
      [KEYWORD_DATA_CONTENT_LAST_CHANGE_TIMESTAMP]:
        data && data[KEYWORD_DATA_CONTENT] && data[KEYWORD_DATA_CONTENT][KEYWORD_DATA_CONTENT_LAST_CHANGE_TIMESTAMP]
          ? data[KEYWORD_DATA_CONTENT][KEYWORD_DATA_CONTENT_LAST_CHANGE_TIMESTAMP]
          : '',
    });
    return AuthorizationFetcher.interceptedFetch(`${requestUrl}/${encodeURIComponent(screenId)}/?${queryParams}`, {method: 'delete'})
      .then((response) => {
        let result;
        // HTTP Error 409 is not considered as an error
        if (response.status === CONFLICT_HTTP_CODE) {
          // return response data and response status
          // TODO: handle json error in response
          result = response.json().then((resultJson) => ({
            _responseData: resultJson,
            _responseStatus: response.status,
          }));
        } else if (response.type === 'opaque' || response.ok) {
          const promise = response.status === utils.FetcherUtils.HTTP_STATUS_NO_CONTENT ? Promise.resolve({}) : response.json();
          result = promise.then((resultJson) => ({
            _responseData: resultJson,
            _responseStatus: response.status,
          }));
        } else {
          utils.FetcherUtils.errorHandler(response);
        }
        return result;
      })
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },
};

export default AutoLayoutFetcher;
